import { useContext, useState, useEffect, useRef, useCallback } from "react";
import { CoreContext } from "context/CoreContext";
import { Create, ReadOne, Update } from "services/core";
import { apiRequest, exposeStrapiError, normalizeStrapiRegister } from "utils";
import { toast } from "react-toastify";
import useI18n from "./useI18n";


export default function useForm({ table, adapter, success, id }) {

    const formRef = useRef()

    const { user } = useContext(CoreContext)

    const { t } = useI18n()

    const [register, setRegister] = useState(null)
    const [loading, setLoading] = useState(false)

    const save = async (payload) => {
        const form = formRef?.current?.getForm()
        if (!form && !payload) return;
        setLoading(true)
        const payloaddata = {
            ...form,
            ...(payload || {}),
            user: user?.id
        }
        const result = id ? await apiRequest(() => Update(table, { data: { ...payloaddata } }, id)) : await apiRequest(() => Create(table, { data: { ...payloaddata } }))
        if (result && !exposeStrapiError(result)) {
            toast.success(id ? t('updated_successfully') : t('created_successfully'))
            init()
            if (typeof success === "function") { success() }
        }
        setLoading(false)
    }


    const init = useCallback(async () => {
        if (id) {
            setLoading(true)
            const result = await apiRequest(() => ReadOne(table, id))
            if (result && !exposeStrapiError(result)) {
                const normalResult = normalizeStrapiRegister(result)
                setRegister(typeof adapter === 'function' ? adapter(normalResult) : { ...normalResult })
            }
            setLoading(false)
        }
    }, [id, table, adapter])

    useEffect(() => { init(); }, [init])

    return {
        loading,
        register,
        formRef,
        save,
        init
    }
}